






























import Vue from 'vue'
export default {
    name: "conninfo",
    props: ['traceid', 'connid'],
    data() {
        return {
            selectedstreams: null,
            streamoptions: [],
            connheight: 62,
            streamheight: 30,
            xoffset: 0
        }
    },
    computed: {
        compheight() {
            let height = 0
            if (this.$store.state.vissettings.getFile(this.traceid).getConn(this.connid).getShowStreams()) {
                height +=  60 * this.$store.state.vissettings.getFile(this.traceid).getConn(this.connid).getAmountStreamsToShow();
            }
            return height + 122;
        },
        filteredstreams() {
            return this.$store.state.vissettings.getFile(this.traceid).getConn(this.connid).getStreamFilters()
        },
        showstreams(){
            return this.$store.state.vissettings.getFile(this.traceid).getConn(this.connid).getShowStreams()
        }
    },
    methods: {
        resetStreamFilters() {
            let data = {
                traceid: this.traceid,
                connid: this.connid,
            }
            this.$store.dispatch('resetStreamFilters', data);
        },
        setShowStreams(){
            let data = {
                traceid: this.traceid,
                connid: this.connid
            }
            this.$store.dispatch('toggleShowStreams', data);
        },
        setXOffset(){
            let data = {
                traceid: this.traceid,
                connid: this.connid,
                xoffset: this.xoffset
            }
            this.$store.dispatch('setXOffset', data)
        },
        filterStream(streamnr: number) {
            let data = {
                traceid: this.traceid,
                connid: this.connid,
                streamnr: streamnr
            }
            this.$store.dispatch('filterStream', data)
        },
        bgcolor(cl_init: boolean, uni_di: boolean) {
            return this.$store.state.vissettings.getStreamColor(cl_init, uni_di);
        }
    },
    mounted() {
        this.colorvalue = this.bgcolor
    },
}
